<!-- gmail-closed-open-03-mobile preview — Gmail ad, toggle between the collapsed inbox row and the expanded message -->
<div class="gm-state-toggle d-flex flex-row justify-content-center">
  <button
    type="button"
    class="gm-state-tab"
    [class.active]="view === 'closed'"
    (click)="selectView('closed')"
  >
    Closed
  </button>
  <button
    type="button"
    class="gm-state-tab"
    [class.active]="view === 'open'"
    (click)="selectView('open')"
  >
    Open
  </button>
</div>

<app-mobile-frame>
  <!-- START: Gmail inbox top bar — pinned above the inbox list -->
  <div frameTop *ngIf="view === 'closed'" class="gm-inbox-topbar">
    <div class="gm-inbox-searchbar d-flex flex-row align-items-center justify-content-between">
      <i class="bi bi-list gm-inbox-icon"></i>
      <span class="gm-inbox-avatar placeholder"></span>
    </div>
  </div>
  <!-- END: Gmail inbox top bar -->

  <!-- START: Gmail message-detail action bar — pinned above the message -->
  <div frameTop *ngIf="view === 'open'" class="gm-topbar d-flex flex-row align-items-center justify-content-between">
    <i class="bi bi-chevron-left gm-icon"></i>
    <div class="gm-topbar-actions d-flex flex-row align-items-center">
      <i class="bi bi-star gm-icon"></i>
      <i class="bi bi-trash gm-icon"></i>
      <i class="bi bi-three-dots gm-icon"></i>
    </div>
  </div>
  <!-- END: Gmail message-detail action bar -->

  <!-- START: Collapsed inbox list -->
  <div class="gm-inbox" *ngIf="view === 'closed'">
    <div class="gm-inbox-tabs">
      <span class="gm-inbox-tab-bar placeholder"></span>
    </div>

    <!-- START: Real ad -->
    <div class="gm-inbox-ad d-flex flex-row">
      <span class="gm-inbox-logo gm-letter-avatar" aria-hidden="true">V</span>

      <div class="gm-inbox-copy">
        <div class="gm-inbox-line1">
          <span class="gm-inbox-sponsored">Sponsored</span> ·
          <span class="gm-inbox-sender">Valamar</span>
        </div>
        <a [href]="data.url || null" target="_blank" rel="noopener noreferrer" class="gm-inbox-headline">
          {{ data.descriptions[0] || "Your description appears here" }}
        </a>
        <a [href]="data.url || null" target="_blank" rel="noopener noreferrer" class="gm-inbox-chip">
          {{ data.headlines[0] || "Your headline appears here" }}
        </a>
      </div>

      <div class="gm-inbox-actions d-flex flex-column align-items-end justify-content-between">
        <i class="bi bi-three-dots-vertical"></i>
        <i class="bi bi-star"></i>
      </div>
    </div>
    <!-- END: Real ad -->

    <!-- Rest of the inbox, skeleton filler -->
    <div class="gm-inbox-row d-flex flex-row" *ngFor="let row of inboxSkeletonRows">
      <span class="gm-inbox-row-avatar placeholder"></span>
      <div class="gm-inbox-row-lines d-flex flex-column">
        <span class="gm-inbox-row-bar gm-inbox-row-bar-short placeholder"></span>
        <span class="gm-inbox-row-bar gm-inbox-row-bar-mid placeholder"></span>
        <span class="gm-inbox-row-bar placeholder"></span>
      </div>
    </div>
  </div>
  <!-- END: Collapsed inbox list -->

  <!-- START: Expanded message -->
  <div class="gm-message" *ngIf="view === 'open'">
    <div class="gm-sender d-flex flex-row">
      <img
        class="gm-logo"
        src="assets/images/google-campaign-logos/collection/valamar-collection-512x512-color.png"
        alt=""
      />
      <div class="gm-sender-text">
        <div class="gm-sender-name">Valamar</div>
        <div class="gm-sender-to">meni</div>
      </div>
    </div>

    <!-- START: Real ad -->
    <a [href]="data.url || null" target="_blank" rel="noopener noreferrer" class="gm-creative-link">
      <img *ngIf="creativeImage" class="gm-creative-image" [src]="creativeImage" alt="" />
      <div *ngIf="!creativeImage" class="gm-creative-image creative-missing">{{ missingDimensionLabel }}</div>
    </a>

    <div class="gm-copy">
      <a [href]="data.url || null" target="_blank" rel="noopener noreferrer" class="gm-headline">
        {{ data.headlines[0] || "Your headline appears here" }}
      </a>
      <div class="gm-desc">
        {{ data.descriptions[0] || "Your description appears here" }}
      </div>
      <a [href]="data.url || null" target="_blank" rel="noopener noreferrer" class="gm-cta">
        <span class="gm-cta-label">{{ data.ctaText || "Your call to action" }}</span>
      </a>
    </div>
    <!-- END: Real ad -->

    <div class="gm-divider"></div>
  </div>
  <!-- END: Expanded message -->

  <!-- START: Gmail bottom nav — pinned below the inbox list -->
  <div
    frameBottom
    *ngIf="view === 'closed'"
    class="gm-inbox-bottomnav d-flex flex-row justify-content-around align-items-center"
  >
    <span class="gm-inbox-bottomnav-btn">
      <i class="bi bi-envelope"></i>
    </span>
    <i class="bi bi-chat-square gm-inbox-bottomnav-icon"></i>
    <i class="bi bi-camera-video gm-inbox-bottomnav-icon"></i>
  </div>
  <!-- END: Gmail bottom nav -->
</app-mobile-frame>
